import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import BlogPost from './BlogPost';
import posts from '../data/data-post.json';
import useRemoteModule from '../../hooks/useRemoteModule';
import { mapBlogItem } from '../../services/contentApi';

function BlogInner() {
    const blogPosts = useRemoteModule('blogs', mapBlogItem, posts);
    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 3;
    const totalPages = Math.ceil(blogPosts.length / postsPerPage);

    const categories = useMemo(() => {
        const counts = blogPosts.reduce((accumulator, post) => {
            accumulator[post.category] = (accumulator[post.category] || 0) + 1;
            return accumulator;
        }, {});

        return Object.entries(counts).map(([title, count]) => ({ title, count }));
    }, [blogPosts]);

    const recentPosts = blogPosts.slice(0, 3);
    const allTags = Array.from(new Set(blogPosts.flatMap((post) => post.tags))).slice(0, 8);

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = blogPosts.slice(indexOfFirstPost, indexOfLastPost);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <section className="th-blog-wrapper space-top space-extra-bottom">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-8 col-lg-7">
                        {currentPosts.map((data) => (
                            <BlogPost
                                key={data.id}
                                blogSlug={data.slug}
                                blogImage={data.image}
                                blogTitle={data.title}
                                blogExcerpt={data.excerpt}
                                blogAuthor={data.author}
                                blogDate={data.publishDate}
                                blogCategory={data.category}
                                blogReadTime={data.readTime}
                            />
                        ))}
                        <div className="th-pagination">
                            <ul>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <li key={i}>
                                        <Link
                                            className={currentPage === i + 1 ? 'active' : ''}
                                            to="#"
                                            onClick={() => handlePageChange(i + 1)}
                                        >
                                            {i + 1}
                                        </Link>
                                    </li>
                                ))}
                                {currentPage < totalPages && (
                                    <li>
                                        <Link className="next-page" to="#" onClick={() => handlePageChange(currentPage + 1)}>
                                            Next <img src="/assets/img/icon/arrow-right4.svg" alt="" />
                                        </Link>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-lg-5">
                        <aside className="sidebar-area">
                            <div className="widget widget_search">
                                <form className="search-form">
                                    <input type="text" placeholder="Search" />
                                    <button type="submit">
                                        <i className="far fa-search" />
                                    </button>
                                </form>
                            </div>
                            <div className="widget widget_categories">
                                <h3 className="widget_title">Categories</h3>
                                <ul>
                                    {categories.map((category) => (
                                        <li key={category.title}>
                                            <Link to="/blog">
                                                <img src="/assets/img/theme-img/map.svg" alt="" />
                                                {category.title}
                                            </Link>
                                            <span>({category.count})</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="widget">
                                <h3 className="widget_title">Recent Posts</h3>
                                <div className="recent-post-wrap">
                                    {recentPosts.map((post) => (
                                        <div className="recent-post" key={post.id}>
                                            <div className="media-img">
                                                <Link to={`/blog/${post.slug}`}>
                                                    <img src={`/assets/img/blog/${post.image}`} alt={post.title} />
                                                </Link>
                                            </div>
                                            <div className="media-body">
                                                <h4 className="post-title">
                                                    <Link className="text-inherit" to={`/blog/${post.slug}`}>
                                                        {post.title}
                                                    </Link>
                                                </h4>
                                                <div className="recent-post-meta">
                                                    <Link to="/blog">
                                                        <i className="fa-regular fa-calendar" />
                                                        {post.publishDate}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="widget widget_tag_cloud">
                                <h3 className="widget_title">Popular Tags</h3>
                                <div className="tagcloud">
                                    {allTags.map((tag) => (
                                        <Link key={tag} to="/blog">
                                            {tag}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default BlogInner;
